import React from "react";
import { Link } from "react-router-dom";
import styles from "./PackageCard.module.css";

export default function PackageCard({
  image,
  title,
  highlights,
  duration,
  price,
  detailsLink,
  destinations,
}) {
  return (
    <div className={styles.card}>
      <img src={image} alt={title} className={styles.cardImage} />

      <h3>{title}</h3>
 <div className={styles.meta}>
        <p><strong>Duration:</strong> {duration}</p>
        <p><strong>Starting Price:</strong> {price}</p>
        <p><strong>Destinations Covered:</strong>{destinations}</p>
      </div>
      <ul className={styles.highlights}>
        {highlights.map((item, index) => (
          <li key={index} dangerouslySetInnerHTML={{ __html: item }} />
        ))}
      </ul>

     

      <div className={styles.buttons}>
        <Link to={detailsLink}>
          <button>View Details</button>
        </Link>

        <Link to="/contact">
          <button className={styles.enquiryBtn}>Enquiry</button>
        </Link>
      </div>
    </div>
  );
}